import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, Suspense as _Suspense, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c0a74d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"1200px","margin":"0 auto 0"} }
const _hoisted_2 = {
  id: "shopcart",
  class: "pt_20"
}
const _hoisted_3 = { class: "viewport" }
const _hoisted_4 = {
  id: "cart",
  class: "s-content rel"
}
const _hoisted_5 = { class: "ft-w-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 0,
  class: "goods-tab"
}
const _hoisted_9 = { class: "tag" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/arrow_icon.png",
  alt: ""
}, null, -1))
const _hoisted_11 = { key: 4 }

import { t } from '@/plugins/i18n'
import { ref, computed, watch, onMounted, toRaw } from 'vue'
import SwitchDeliver from './components/SwitchDeliver.vue'
import ShopTable from './components/ShopTable.vue'
import FigurePay from './components/FigurePay.vue'
import PriceRate from './components/PriceRate.vue'
import ConfirmOrder from './components/ConfirmOrder.vue'
import ChoiceConfirmOrder from './components/choice/ConfirmOrder.vue'
import Guide from '@/components/guide/index.vue'
import ChoiceShopTable from './components/choice/ShopTable.vue'
import OpenMemberTip from './components/OpenMemberTip.vue'
import OpenMember from './components/OpenMember.vue'
import FreeShipping from '@/views/goods/components/FreeShipping.vue'
import { getRelIngt, searchIsInStoreApi, createOrderPreCheckApi, canUseOnTheWayStockApi, updateShopcartApi } from '@/apis/shopcart'
import { getIsShowCustomsApi, hasOrderAvailableTransportationNums, pageOrderOnTheWayStockApi, getD2cMoneyApi } from '@/apis/order'
// import { useGlobal } from '@/util/useLoading'
import calcLadder, { flatCart, calcGp, setStock } from '@/util/calcLadder'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useRtfix, isD2C, isKO, isEN, isJA, isMultiStore, isChoiceShop, isShowStockJpBtn } from '@/store'
import UploadFileBtn from './components/UploadFileBtn.vue'
import { arr2map } from '@/plugins/utils'
import NoStockModal from './components/NoStockModal.vue'
import KrCustomsTip from '@/components/common/KrCustomsTip/index.vue'
import CommonTip from '@/components/CommonTip/index.vue'
import ConfirmStockModal from './ConfirmStockModal.vue'
import bus from '@/util/useBus'
import { sourceCountryRef, sourceCountryInfo, tCurrency } from './country'
import { COUNTRY } from '@/global'
import NewUserTip from './components/NewUserTip.vue'
import OrderExhausted from './components/OrderExhausted.vue'
import GuidePlat from './components/GuidePlat.vue'
import useChoice from './useChoice'
import CartBcIntro from './components/CartBcIntro.vue'
import CountdownTimer from './CountdownTimer.vue'
import UnRechargeModal from '@/components/UnRechargeModal/index.vue'
import { request } from '@/config/request/interceptors'
import { ShopType } from '@/common/const'
import StockJp from './stockJp/index.vue'
import { CartGroupItemDTO, CartItemDTO } from '@/service/order'
interface Sku {
  onTheWayStockQuantity: number
  checked: boolean
  cartId: number
  productCode: string
  productPriceLadderList: any[]
  orderQuantity: number
  stockQuantity: number
  productType: number
  buyQuantity: number
  price: number
  totalPrice: number
  adtPrice: number
  cartAdditionList: any[]
  combinationProductItemList: any[]
  notInStorage?: number
  productSku?: string
  productStatus?: number
  originalstockQuantity?: number
  consignPrice?: number
  isOnePsale?: boolean
  livePriceFlag?: number
  productSellPrice?: number
  minOrderQuantity?: number
  noPriceLadder?: boolean
}
interface Shop {
  cartList: Sku[]
  productType?: number
}

/** 一键下单的在途库存弹窗 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const router = useRouter()
const Layout1 = [
  { label: '商品名称', name: 'title', width: 'auto' },
  { label: t('客户商品sku'), name: 'customSku', width: 140 },
  { label: '商品属性', name: 'sku', width: 120 },
  { label: '下单数量', name: 'amount', width: 120 },
  { label: t('单价') + tCurrency('CNY'), name: 'price', width: 110 },
  { label: t('小计') + tCurrency('CNY'), name: 'total', width: 110 },
  { label: '商品附加项', name: 'adt', width: 150 },
  { label: '操作', name: 'run', width: 140 }
].fort()
/** 是否日本仓 */
const isJpTitkTokShop = computed(() => showTiktok.value && sourceCountryRef.value === COUNTRY.JP)
/** tiktok店铺，非韩国仓 */
const showTiktok = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C() && sourceCountryRef.value !== COUNTRY.KR)

const Layout2 = computed(() => {
  let title = '使用库存/采购数量'
  if (showTiktok.value || sourceCountryRef.value === COUNTRY.JP) {
    title = `注文利用数/${t(sourceCountryRef.value === COUNTRY.JP ? '日本仓' : '中国仓')}${t('总在库数')}`
  }
  return [
    { label: '商品名称', name: 'title', width: 260, headerWidth: 210 },
    { label: t('客户商品sku'), name: 'customSku', width: 140 },
    { label: '商品属性', name: 'sku', width: 110 },
    { label: '下单数量', name: 'amount', width: 120 },
    { label: title, name: 'store', width: isEN() ? 130 : 110 },
    { label: t('单价') + tCurrency('CNY'), name: 'price', width: 110 },
    { label: t('小计') + tCurrency('CNY'), name: 'total', width: 110 },
    { label: '商品附加项', name: 'adt', width: 150 },
    { label: '操作', name: 'run', width: 70 }
  ].fort()
})
/** 是否显示 choice 商品列表 */
const showChoice = computed(() => {
  const fixedChoiceShow = choiceCartList.value.length && isJA()
  return (isChoiceShop() && ((isD2C() && mode.value === 1) || !isD2C()) && sourceCountryRef.value === COUNTRY.CN) || (fixedChoiceShow && ((isD2C() && mode.value === 1) || !isD2C()))
})

/** 直发/囤货模式及对应的购物车列表布局 */
const modes = [
  {
    label: 'C端直发',
    value: 1,
    img: require('@/assets/image/d2c.jpg'),
    layout: Layout2.value
  },
  {
    label: '采购到库存',
    value: 0,
    img: require('@/assets/image/b2b.jpg'),
    layout: Layout1
  }
].fort()
/** 备货到日本组件 */
const stockJpRef = ref()
/** 直发/囤货模式 */
const mode = ref(isD2C() ? 1 : 0)
/** 购物车列表显示表头布局 */
const layout = computed(
  () => modes.find((v) => v.value === mode.value)?.layout ?? []
)
/** 地址校验 */
const addressValid = ref(() => Promise.resolve(null))
/** 用户会员信息 */
const membership = store.getters.membership

const confirmStockModal = ref()
/** 购物车列表数据 */
const list = ref<CartGroupItemDTO[]>([])
/** 购物车勾选数据 cartId */
const listCheckMap = ref<Record<number, boolean>>({})
let oldListCheckMap: any = {}
/** 是否禁用下单按钮 */
const disabled = computed(
  () => (Object.values(listCheckMap.value).filter((v) => v).length === 0 && Object.keys(checkMap.value)?.length === 0)
)
/** 筛选勾选后有商品的购物车 id */
const cartIdList = computed(() =>
  Object.entries(listCheckMap.value)
    .filter((ety) => ety[1])
    .map(([k]) => k)
)

/** 所有勾选的商品数据 */
const checkList = computed(() => {
  const arr: any = []
  list.value.forEach((v) => {
    v.cartList?.forEach((item) => {
      listCheckMap.value[item.cartId!] && arr.push(item)
    })
  })
  return arr
})

/** 失效商品数据判断 */
const isInvalid = (item: any) => {
  if (mode.value === 1) {
    // 直发没有库存并失效的才算
    return ([1, 2, 6, 7].includes(item.productStatus) || item.blackTag) && item.stockQuantity === 0
  }
  return [1, 2, 6, 7].includes(item.productStatus) || item.blackTag
}
/**
 * 将商品区分为失效商品和正常商品加上标记并返回一个列表
 * @param cartList 
 */
const margeListData = (cartList: any) => {
  console.log(cartList)
  const invalidGoods: any = {
    cartList: [],
    disabled: true,
    cartGroupName: t('失效商品'),
    invalidGoods: true
  }
  const normalList: any = []
  cartList.forEach((item: any) => {
    if (item.cartList.filter((v: any) => !isInvalid(v)).length > 0) {
      normalList.push({
        ...item,
        cartList: item.cartList.filter((v: any) => !isInvalid(v))
      })
    }
    item.cartList?.forEach((cartItem: any) => {
      if (isInvalid(cartItem)) {
        invalidGoods.cartList.push(cartItem)
      }
    })
  })
  return [
    ...normalList,
    ...(invalidGoods.cartList.length > 0 ? [invalidGoods] : [])
  ]
}

/**
 * 参数：直发，囤货，商品所在地（中国/韩国），仓库所在地（中国/日本）
 * 获取购物车列表 （此处会根据）
 */
const getData = () => {
  store.commit('status/loading', true)
  return request.order.cart.list({
    orderType: mode.value === 1 ? 1 : 2,
    goodsCountry: sourceCountryRef.value === COUNTRY.KR ? COUNTRY.KR : COUNTRY.CN,
    wareHouseLocation: sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN
  }).then(async (res) => {
    if (res?.success) {
      const cartList = margeListData(res.data) as CartGroupItemDTO[]
      cartList.forEach((item) => {
        item.cartList?.forEach((cartItem) => {
          // 新增原始库存字段，使用商品stockQuantity字段
          cartItem.originalstockQuantity = cartItem.stockQuantity ?? 0
          // 增加是否存在阶梯价字段 一件代发商品都存在阶梯价所以productPriceLadderList不准了
          cartItem.noPriceLadder = !cartItem.productPriceLadderList?.length
          // 组合商品子商品
          if (cartItem?.combinationProductItemList?.length) {
            cartItem?.combinationProductItemList?.forEach((comItem: any) => {
              // 组合子商品是否存在阶梯价
              comItem.noPriceLadder = !comItem.productPriceLadderList?.length
              // 新增原始库存字段，使用商品stockQuantity字段
              comItem.originalstockQuantity = comItem.stockQuantity ?? 0
            })
          }
          // 直播商品去掉区间价
          if (cartItem.livePriceFlag === 1) {
            cartItem.productPriceLadderList = null
            // 直播商品不走一件代发逻辑
            cartItem.isOnePsale = false
          }

          // 子商品带阶梯价且是一件代发商品需要把一件代发价补充到productPriceLadderList第一个
          if (cartItem?.productPriceLadderList?.length && cartItem.isOnePsale) {
            if (cartItem.productPriceLadderList[0].count !== 1) {
              cartItem.productPriceLadderList.unshift({
                count: 1,
                price: cartItem.consignPrice,
                isOnePsale: true
              })
            }
          }
          // 没有阶梯价且是一件代发
          if (!cartItem.productPriceLadderList?.length && cartItem.isOnePsale) {
            cartItem.productPriceLadderList = [
              {
                count: cartItem.minOrderQuantity,
                price: cartItem.productSellPrice
              }
            ]
            if (cartItem.minOrderQuantity && cartItem.minOrderQuantity > 1) {
              cartItem.productPriceLadderList.unshift({
                count: 1,
                price: cartItem.consignPrice,
                isOnePsale: true
              })
            }
          }
        })
      })
      list.value = cartList
    }
  }).finally(() => {
    store.commit('status/loading', false)
  })
}

const update = () => getData().then(calcPrice)
// 其他地方更改购物车后触发更新
store.commit('goods/useUpdate', update)
// 监听发货仓切换
// watchSourceCountry(async () => {
//   listCheckMap.value = {}
//   list.value = []
//   await init()
// })
// 切换直发 囤货重新触发
watch(mode, () => {
  if (mode.value === 2) return
  listCheckMap.value = {}
  init()
})
const isTikTokShop2C = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C())

/**
 * 计算商品阶梯价和附加费
 */
const calcPrice = async () => {
  // 整理购物车数据
  const [skuList, group, groupGoods] = await flatCart(
    {
      list: list.value,
      listCheckMap: listCheckMap.value,
      mode: mode.value,
      isUseOnTheWayStock: isUseOnTheWayStock.value,
      sourceCountry: sourceCountryRef.value
    }
  )

  flatList.value = skuList
  // 组合使用落单子商品需传的参数 严重 bug（此处永远返回空数组，勿动!!!）
  remainList.value = await setStock(groupGoods, mode.value, listCheckMap.value)

  // 算价逻辑
  await calcLadder(skuList, listCheckMap.value, !mode.value)
  await calcGp(group, mode.value)
  calcFee()
  console.log(list.value, 'list.value1')
}

const scrollBarFn = () => {
  let itemIndex = 0
  let tempIndex = 0
  let isReturn = false
  list.value.forEach((item: any, index: any) => {
    if (isReturn) return
    itemIndex++
    item.cartList.forEach((temp: any, key: any) => {
      if (temp.shitProp) {
        isReturn = true
      }
      if (isReturn) return
      tempIndex++
    })
  })
  const ele: any = document.querySelector('.el-scrollbar>.el-scrollbar__wrap')
  ele.scrollTo(0, (isD2C() ? (mode.value === 1 ? 376.5 : 167.5) : 141.5) + (itemIndex * 66) + (110 * tempIndex) + (itemIndex - 1) * 30)
}
const remainList = ref([])
const flatList = ref([])

watch([cartIdList], calcPrice)
watch(() => mode.value, calcPrice)
/** 所有商品 sku */
let sku: string[] = []
/**
 * 购物车初始化函数
 * @param type type 是否刷新后保留原先勾选状态
 */
const init = async (type?: boolean) => {
  //   当为直发单才需要判断是否在途库存
  if (mode.value === 1) {
    await initIsCanUseOnTheWayStock()
  } else {
    isCanUseOnTheWayStock.value = false
  }

  getData().then(() => {
    sku = []
    list.value.forEach((v) => {
      v.cartList?.forEach((item) => {
        // 默认不勾选
        listCheckMap.value[item.cartId!] = type ? oldListCheckMap[item.cartId!] : false
        // 如果notInStorage不为0不能勾选
        if (item.notInStorage === 0) {
        } else {
          // 处理插件加购时需要更新的sku
          item.productSku && sku.push(item.productSku)
        }
      })
    })
    // 插件数据更新逻辑
    if (sku.length > 0) {
      setTimeGetStock()
    }
    calcPrice(type)
  })
  // if (!isChoiceShop) return
  choiceFn.getChoiceList(mode.value)
}
/** 备货到日本后端灰度状态 */
const showBtn = ref(false)
onMounted(async () => {
  showBtn.value = await isShowStockJpBtn()
  if (showBtn.value && route.query.mode === '2') {
    mode.value = 2
  }
  init()
})
/** 用户是否可以使用在途库存 */
const isCanUseOnTheWayStock = ref(false)
/** 用户是否选择使用在途库存 */
const isUseOnTheWayStock = ref(false)
/** 是否可以使用在途函数 */
const initIsCanUseOnTheWayStock = async () => {
  const data = await canUseOnTheWayStockApi()
  isCanUseOnTheWayStock.value = data.data
}
let timer: any = null
/** （插件入库）定时查询购物车未入库商品状态 */
const setTimeGetStock = () => {
  clearTimeout(timer)
  if (sku.length === 0) return
  searchIsInStoreApi({
    productSkuList: sku
  }).then((res) => {
    if (res.success && res.data.length > 0 && route.meta.name === 'shopcart') {
      // 数据有更新，重新刷新列表
      timer = setTimeout(() => {
        init()
      }, 2000)
    } else if (route.meta.name === 'shopcart') {
      timer = setTimeout(() => {
        setTimeGetStock()
      }, 2000)
    }
  })
}
/** 监听是否选择在途库存 */
watch(isUseOnTheWayStock, async (newValue) => {
  //   选中的shopProductSku集合,需要请求在途库存数量
  const shopProductSkus = new Set()
  checkList.value?.forEach((item: any) => {
    // 如果是组合商品，则将子商品的sku传进去，主商品就不用传进去
    if (item.combinationProductItemList?.length) {
      item.combinationProductItemList.forEach((comitem: any) => {
        shopProductSkus.add(comitem.shopProductSku)
      })
    } else {
      shopProductSkus.add(item.shopProductSku)
    }
  })
  if ((!isTikTokShop2C.value) && (sourceCountryRef.value !== COUNTRY.JP)) {
    //   请求在途库存列表
    const data = await pageOrderOnTheWayStockApi({ shopProductSkus: Array.from(shopProductSkus), goodsCountry: sourceCountryRef.value, pageNum: 1, pageSize: 300 })
    const onTheWayStockList: any[] = data?.data?.records ?? []
    //   如果在途列表没有就直接不进行下面操作
    if (!onTheWayStockList.length) {
      return
    }

    checkList.value.map(async (item: any) => {
      // 如果是组合商品，则直接循环子商品是否有在途，目前没有主商品使用在途的概念
      if (item.combinationProductItemList?.length) {
        item.combinationProductItemList.forEach((comItem: any) => {
          const sigleOnTheWayStock = onTheWayStockList?.find(wayItem => wayItem.shopProductSku === comItem.shopProductSku)
          const onTheWayAvailableNum = Number(sigleOnTheWayStock?.onTheWayAvailableNum ?? 0)
          comItem.onTheWayAvailableNum = onTheWayAvailableNum
        })
      } else {
        // 一一匹配，将库存加上在途库存的值
        const sigleOnTheWayStock = onTheWayStockList?.find(wayItem => wayItem.shopProductSku === item.shopProductSku)
        const onTheWayAvailableNum = Number(sigleOnTheWayStock?.onTheWayAvailableNum ?? 0)
        item.onTheWayAvailableNum = onTheWayAvailableNum
      }
    })
    calcPrice()
  }
})

/** 商品价格 */
const pdtFee = ref(0)
/** 附加项价格 */
const adtFee = ref(0)
/** 囤货商品同样计算在内的订单价值 直发不可超过一定金额 */
const valueFee = ref(0)
/** 本期支付总金额 */
const curPdtFee = ref(0)
// d2c直发最大金额
const D2CMaxMoney = computed(() => store.getters['d2cOrderAmount/getD2cMoney'])
const calcFee = () => {
  let m = 0
  let n = 0
  let l = 0
  let p = 0
  checkList.value.forEach((item: any) => {
    m += item.totalPrice
    n += item.adtPrice ?? 0
    l += item.valuePrice
    p += item.curPdtPirce
  })

  pdtFee.value = m
  adtFee.value = n
  valueFee.value = l
  curPdtFee.value = p
}

const createGroup = () => {
  const data = checkList.value
  const g = data.find((v: any) => v.productType === 3)
  const o = data.find((v: any) => [1, 3].includes(v.oemOrderType))
  if (g) {
    ElMessage.error(t('组合商品不能再组合'))
  } else if (o) {
    ElMessage.error(t('OEM样品单不能组合'))
  } else {
    store.commit('goods/groupList', data)
    router.push(useRtfix('groupProduct', { query: { from: 'cart' } }))
  }
}

const preview = ref(false)
const openMemberRef = ref()
/** 点击提出后第二步 */
const commitConfirm = async () => {
  let isWarn = false
  // 提交订单前 校验商品是否失效下架
  if (checkList.value.filter((i: any) => (mode.value === 0 && i.productType !== 3) || mode.value === 1)?.length > 0) {
    isWarn = await isHaveErrorGoods()
  }
  if (isWarn) {
    oldListCheckMap = listCheckMap.value
    listCheckMap.value = {}
    init(true)
    return
  }
  preview.value = true
}

// 是否日本仓
const isExtStock = computed(() => (checkList.value.some((goods: any) => (goods.productType === 3) ? goods.combinationProductItemList.some(i => i.buyQuantity > 0) : goods.orderQuantity > goods.stockQuantity)) && (sourceCountryRef.value === COUNTRY.JP || isTikTokShop2C.value) && mode.value === 1)

const orderExhausted = ref()
// 提出
const commit = async () => {
  // choice
  if (cartGoodsMode.value === 2) {
    if (mode.value === 1) {
      const valid = await addressValid.value()
      if (!valid) {
        ElMessage.error(t('请将收货人信息填写完整后提交订单'))
        return
      }
    }

    // 校验起订量
    console.log('checkMap.value', checkMap.value)
    if (Object.values(checkMap.value).some((v: any) => choiceFn.getCartIdLackStatus(v).lack || choiceFn.getCartIdLackStatus(v).goodsLack)) {
      ElMessage.error(t('存在不足起订量的商品，请修改数量'))
      return
    }

    if (Object.values(checkMap.value).some((v: any) => !v.cartAdditionList?.length && v.noAdditionalFlag !== 1)) {
      ElMessage.error(t('附加项验证'))
      return
    }

    if (cartGoodsMode.value === 2) {
      store.commit('status/loading', true)
      await updateShopcartApi({
        productCodes: Object.values(checkMap.value).map(v => v.productCode)
      }).finally(() => {
        store.commit('status/loading', false)
      })
    }
    choiceConfirmOrdeRef.value.open()
    return
  }
  const noAddList: any = []
  checkList.value.forEach((v: any) => {
    if (v.productType !== 3) {
      if (v.buyQuantity === 0) return
      if (!(v.cartAdditionList?.length || v.noAdditionalFlag)) {
        noAddList.push(v)
      }
    } else {
      v.combinationProductItemList.forEach((v2: any) => {
        if (v.buyQuantity === 0) return
        if (!(v2.additionList?.length || v2.noAdditionalFlag)) {
          noAddList.push(v2)
        }
      })
    }
  })
  if (noAddList.length && !isJpTitkTokShop.value) {
    const first = noAddList[0].cartId ?? noAddList[0].shopProductSku
    const top = document.getElementById(first)?.getBoundingClientRect()?.top ?? 180
    store.commit('observe/trigger', { scroll: top - 180 + store.state.observe.scroll })
    //
    noAddList.forEach((v: any) => {
      v.showTip = true
      setTimeout(() => { v.showTip = false }, 1000)
    })
    ElMessage.error(t('附加项验证'))
    return
  }
  // tiktok直发单校验库存

  if (mode.value === 1) {
    // 是否超库存购买
    if (isExtStock.value) {
      ElMessage.error(t(t('超出库存，无法下单，请提前备货')))
      return
    }
    const { data: money } = await getD2cMoneyApi({ currencyCode: sourceCountryInfo.value?.currency })
    // 拦截金额按照附加项 + 商品实际金额
    if ((valueFee.value + adtFee.value) > money) {
      ElMessage.error(
        t('单笔订单价值不得超过XX元，请调整商品数量').replace(
          'XX',
          String(money)
        ).replace('元', tCurrency('元'))
      )
      return
    }
    const valid = await addressValid.value()
    if (!valid) {
      ElMessage.error(t('请将收货人信息填写完整后提交订单'))
      return
    }
  }
  if (flatList.value.some((v: any) => v.lack)) {
    ElMessage.error(t('存在不足起订量的商品，请修改数量'))
    return
  }

  judgeCanUseOnTheWayStock()
}
/** 判断是否可以使用在途库存,是否打开在途确认页 */
const judgeCanUseOnTheWayStock = async () => {
  if (mode.value !== 1 || !isCanUseOnTheWayStock.value) {
    commitConfirm()
    return
  }
  //   选中的shopProductSku集合
  //   const shopProductSkus = checkList.value?.map(item => item.shopProductSku)
  const shopProductSkus = new Set()
  checkList.value?.forEach((item: any) => {
    // 如果是组合商品，则将子商品的sku传进去，主商品就不用传进去
    if (item.combinationProductItemList?.length) {
      item.combinationProductItemList.forEach((comitem: any) => {
        shopProductSkus.add(comitem.shopProductSku)
      })
    } else {
      shopProductSkus.add(item.shopProductSku)
    }
  })
  if (!isTikTokShop2C.value && sourceCountryRef.value !== COUNTRY.JP) {
    //   当为直发单，且账号处于可以使用在途库存白名单内
    const data = await hasOrderAvailableTransportationNums({ shopProductSkus: Array.from(shopProductSkus), goodsCountry: sourceCountryRef.value !== COUNTRY.KR ? COUNTRY.CN : COUNTRY.KR })
    if (data?.data) {
      confirmStockModal.value.open()
      return
    }
  }
  commitConfirm()
}
/** 在途库存弹窗确认 */
const confirmStockSuccess = async (val: boolean) => {
  // 是否使用在途库存
  isUseOnTheWayStock.value = val
  commitConfirm()
}

const isHaveErrorGoods = () => {
  return request.order.cart.createOrderPreCheck({
    orderType: mode.value === 1 ? 1 : 2,
    wareHouseLocation: mode.value === 1 && sourceCountryRef.value === COUNTRY.JP ? COUNTRY.JP : COUNTRY.CN,
    // 组合商品囤货不校验失效商品库存
    cartIds: checkList.value.filter((i: any) => (mode.value === 0 && i.productType !== 3) || mode.value === 1).map((item: any) => item.cartId)
  }).then((res: any) => {
    const { invalidProductSkuList, banProductSkuList, stockNotEnoughList } = res.data
    let errorText = ''
    if (invalidProductSkuList.length > 0 || banProductSkuList.length > 0) {
      const map = arr2map([
        ...invalidProductSkuList,
        ...banProductSkuList
      ])
      const sku: any[] = []
      checkList.value.forEach((v: any) => {
        if (v.productType === 3 && mode.value === 1) {
          v.combinationProductItemList.forEach((item: any) => {
            sku.push(item)
          })
        } else {
          sku.push(v)
        }
      })
      sku.some(v => {
        if (map.get(v.productSku)) {
          console.log(v.productSku, { ...v }, { isHaveErrorGoods })
          if (v.onTheWayStockQuantity < v.orderQuantity) {
            errorText = invalidProductSkuList.length > 0 && banProductSkuList.length > 0 ? t('多个商品有异常，请重新调整商品') : invalidProductSkuList.length > 0 ? t('存在已失效商品，请调整商品') : t('存在已下架商品，请调整商品')
            return true
          }
        }
      })
    }
    if (stockNotEnoughList.length > 0) {
      errorText = errorText ? t('多个商品有异常，请重新调整商品') : t('存在库存过低商品，请调整发货量或及时补充库存')
      console.log('库存不足', checkList.value, stockNotEnoughList)
      const underlineGoos = checkList.value.filter((i: any) => stockNotEnoughList.includes(i.productSku))
      if (underlineGoos.length > 0) {
        // 线下商品库存不足的时候弹窗
        noStockVisible.value = true
        noStockGoods.value = underlineGoos
        return true
      }
    }
    if (!errorText) {
      return false
    } else {
      ElMessage({
        dangerouslyUseHTMLString: true,
        message: errorText,
        type: 'error'
      })
      return true
    }
  })
}
const success = async (fn: any) => {
  preview.value = false
  const vals: any = []
  checkList.value.forEach((v: any) => {
    if (v.oemProductClassificationId === 3) {
      vals.push(v.shopProductSku)
    }
  })
  Object.entries(listCheckMap.value).forEach(([k, v]) => {
    v && delete listCheckMap.value[k]
  })
  // 查询下单商品是否有未绑定的辅料
  let hasIngt = false
  if (vals.length) {
    hasIngt = await getRelIngt({ ingredientsSkuList: [...vals] }).then((res) => {
      return res.data.filter((v: any) => v.relatedFlag).length !== vals.length
    })
  }
  await update()
  fn(hasIngt)
}

// 是否数量超过2
const isNumberExceed: any = computed(() => {
  let number = 0
  list.value.forEach((v: any) => {
    v.cartList.forEach((v: any) => {
      if (cartIdList.value.includes(v.cartId)) {
        number += v.orderQuantity
      }
    })
  })
  return number > 1 || totalAmount.value.totalQuantity > 1
})
// 下单购买商品总数量
const totalBuyQuantity: any = computed(() => {
  let number = 0
  list.value.forEach((v: any) => {
    v.cartList.forEach((v: any) => {
      if (cartIdList.value.includes(v.cartId)) {
        number += v.orderQuantity
      }
    })
  })
  return number
})
/** 非提交时，关闭在途库存弹窗，则不使用在途 */
const confirmStockClose = (iscommit: boolean) => {
  if (!iscommit) {
    isUseOnTheWayStock.value = false
  }
}

const close = (isReload?: boolean | number, stockList?: any) => {
  isUseOnTheWayStock.value = false
  preview.value = false

  if (isReload === 1) {
    init()
    return
  }
  if (isReload) {
    if (stockList?.length > 0) {
      noStockVisible.value = true
      noStockGoods.value = stockList
    }
    // 如果存在异常商品重新刷新购物车列表
    oldListCheckMap = listCheckMap.value
    listCheckMap.value = {}
    init(true)
  }
}

// 线下商品没有库存的情况下展示提示弹窗
const noStockVisible = ref(false)
const noStockGoods = ref([])
const customsCallback = () => {
  getKrStatus()
}

const getKrStatus = () => {
  if (!isD2C() && isKO()) {
    // 2b 和韩国站才调用
    getIsShowCustomsApi({
      type: 1
    }).then((res: any) => {
      if (res.success) {
        isShowKrTip.value = res.data
      }
    })
  }
}
// 是否需要弹韩国站
const isShowKrTip = ref(false)
getKrStatus()

bus.on('microappUpdateCart', (k: string) => {
  init()
})

// bus.on('orderExhausted', () => {
//   orderExhausted.value?.check()
// })

/**
 * xxx
 * choice 商品逻辑处理
 * xxx
 * xxx
 */
const choiceConfirmOrdeRef = ref()
const { choiceCartList, choiceFn, transportType, changeTransportType, totalAmount, checkMap, requestNum } = useChoice()
const tabStatus = ref(1)
const goodsTableRef = ref()
const choiceTableRef = ref()
watch(() => store.state.observe.scroll, (newValue) => {
  if (goodsTableRef.value?.getBoundingClientRect()?.top < 185) {
    tabStatus.value = 1
  }
  if (choiceTableRef.value?.getBoundingClientRect()?.top < 185) {
    tabStatus.value = 2
  }
}, {
  immediate: true
})
const changeTab = (type: number) => {
  const top = goodsTableRef.value?.offsetTop ?? 0
  const height = goodsTableRef.value?.getBoundingClientRect()?.height ?? 0
  console.log(mode.value, height, goodsTableRef.value.offsetTop)
  const scorllObj: any = {
    // 直发
    1: {
      // 代采
      1: top - 52,
      // choice
      2: top + height
    },
    // 囤货
    0: {
      // 代采
      1: top - 52,
      // choice
      2: top + height
    }
  }
  store.commit('observe/trigger', { scroll: scorllObj[mode.value][type] })
  tabStatus.value = type
}
// 0 1代采 2choice
const cartGoodsMode = computed(() => {
  return Object.keys(checkMap.value)?.length > 0 ? 2 : cartIdList.value?.length > 0 ? 1 : 0
})

const normalCartGoodsNumber = computed(() => {
  return list.value.reduce((acc: number, v: any) => v.cartList?.length + acc, 0)
})
const choiceCartGoodsNumber = computed(() => {
  return choiceCartList.value.reduce((acc: number, v: any) => v.cartList?.length + acc, 0)
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CommonTip, {
        name: _unref(isD2C)() ? 'stopWarehouse,stopPurchaseOrder,stopPurchase' : 'stopPurchase,stopPurchaseOrder'
      }, null, 8, ["name"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "tabs"),
          (!_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "upload-file-btn abs",
                style: _normalizeStyle({ top: _unref(membership).templateLevel === 0 ? '18px' : '18px' })
              }, [
                _createVNode(UploadFileBtn, {
                  mode: 0,
                  onSuccess: init,
                  isCanUseOnTheWayStock: isCanUseOnTheWayStock.value
                }, null, 8, ["isCanUseOnTheWayStock"])
              ], 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["top", { 'top-bo-border': _unref(isMultiStore)() }])
          }, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('购物车')), 1)
            ])
          ], 2),
          (_unref(isJA)())
            ? (_openBlock(), _createBlock(FreeShipping, {
                key: 1,
                scene: 2,
                style: {"padding-top":"10px"}
              }))
            : _createCommentVNode("", true),
          _hoisted_6,
          (_unref(isD2C)())
            ? (_openBlock(), _createBlock(SwitchDeliver, {
                key: _unref(sourceCountryRef),
                isCanUseOnTheWayStock: isCanUseOnTheWayStock.value,
                mode: mode.value,
                "onUpdate:mode": _cache[0] || (_cache[0] = ($event: any) => ((mode).value = $event)),
                modes: _unref(modes),
                onUpdateDeliver: _cache[1] || (_cache[1] = (data) => (addressValid.value = data)),
                onSuccess: _cache[2] || (_cache[2] = ($event: any) => (mode.value === 0 && init())),
                checkList: _unref(checkList),
                isChoice: _unref(cartGoodsMode) === 2,
                showBtn: showBtn.value
              }, null, 8, ["isCanUseOnTheWayStock", "mode", "modes", "checkList", "isChoice", "showBtn"]))
            : _createCommentVNode("", true),
          ([0, 1].includes(mode.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_unref(showChoice))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["goods-tab-item", { active: tabStatus.value === 1 }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(1)))
                      }, _toDisplayString(_unref(t)('代采商品')) + _toDisplayString(_unref(normalCartGoodsNumber) > 0 ? `(${_unref(normalCartGoodsNumber)})` : ''), 3),
                      _createElementVNode("div", {
                        class: _normalizeClass(["goods-tab-item", { active: tabStatus.value === 2 }]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTab(2)))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('Choice商品')) + _toDisplayString(_unref(choiceCartGoodsNumber) > 0 ? `(${_unref(choiceCartGoodsNumber)})` : ''), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createTextVNode(_toDisplayString(_unref(t)('一口价')) + " ", 1),
                          _hoisted_10
                        ])
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  ref: (_value, _refs) => {
                    _refs['goodsTableRef'] = _value
                    goodsTableRef.value = _value
                  }
                }, [
                  _createVNode(ShopTable, _mergeProps({
              cartIdList: _unref(cartIdList),
              listCheckMap: listCheckMap.value,
              list: list.value,
              layout: _unref(layout),
              mode: mode.value,
              refKey: _unref(sourceCountryRef),
              choiceDisabled: _unref(cartGoodsMode) === 2,
              checkList: _unref(checkList),
              showChoice: _unref(showChoice),
              isJpTitkTokShop: _unref(isJpTitkTokShop)
            }, {
                    onUpdate: update,
                    onCalc: calcPrice
                  }), null, 16)
                ], 512),
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(PriceRate)
                  ]),
                  _: 1
                })),
                (_unref(showChoice))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      ref: (_value, _refs) => {
                        _refs['choiceTableRef'] = _value
                        choiceTableRef.value = _value
                      }
                    }, [
                      _withDirectives(_createVNode(ChoiceShopTable, _mergeProps({
              list: _unref(choiceCartList),
              choiceFn: _unref(choiceFn),
              transportType: _unref(transportType),
              changeTransportType: _unref(changeTransportType),
              totalAmount: _unref(totalAmount),
              normalDisabled: _unref(cartGoodsMode) === 1 || _unref(isTikTokShop2C) || _unref(sourceCountryRef) === _unref(COUNTRY).JP,
              isTikTokShop2C: _unref(isTikTokShop2C),
              checkMap: _unref(checkMap)
            }, {
                        onRefresh: _cache[5] || (_cache[5] = async () => {
              await _unref(choiceFn).calcCheckPrice()
            })
                      }), null, 16), [
                        [_directive_loading, _unref(requestNum) > 0]
                      ])
                    ], 512))
                  : _createCommentVNode("", true),
                _createVNode(FigurePay, {
                  isExtStock: _unref(isExtStock),
                  pdtFee: pdtFee.value,
                  adtFee: adtFee.value,
                  curPdtFee: curPdtFee.value,
                  disabled: _unref(disabled),
                  onCommit: commit,
                  onCreateGroup: createGroup,
                  mode: mode.value,
                  isNumberExceed: _unref(isNumberExceed),
                  totalBuyQuantity: _unref(totalBuyQuantity),
                  showNum: true,
                  choiceTotalAmount: _unref(totalAmount),
                  isChoice: _unref(cartGoodsMode) === 2,
                  cartGoodsMode: _unref(cartGoodsMode)
                }, null, 8, ["isExtStock", "pdtFee", "adtFee", "curPdtFee", "disabled", "mode", "isNumberExceed", "totalBuyQuantity", "choiceTotalAmount", "isChoice", "cartGoodsMode"]),
                _createVNode(ConfirmOrder, _mergeProps({
                  modelValue: preview.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((preview).value = $event))
                }, {
            pdtFee: pdtFee.value,
            adtFee: adtFee.value,
            curPdtFee: curPdtFee.value,
            cartIdList: _unref(cartIdList),
            list: list.value,
            addressValid: addressValid.value,
            remainList: remainList.value,
            isTikTokShop2C: _unref(isTikTokShop2C),
          }, {
                  layout: _unref(layout).slice(0, -1),
                  modeConfig: _unref(modes)[mode.value ? 0 : 1],
                  onSuccess: success,
                  onUpdate: update,
                  onClose: close,
                  modeValue: mode.value,
                  isUseOnTheWayStock: isUseOnTheWayStock.value,
                  checkList: _unref(checkList)
                }), null, 16, ["modelValue", "layout", "modeConfig", "modeValue", "isUseOnTheWayStock", "checkList"]),
                _createVNode(ConfirmStockModal, {
                  ref: (_value, _refs) => {
                    _refs['confirmStockModal'] = _value
                    confirmStockModal.value = _value
                  },
                  onClose: confirmStockClose,
                  onSuccess: confirmStockSuccess,
                  checkList: _unref(checkList)
                }, null, 8, ["checkList"])
              ]))
            : _createCommentVNode("", true),
          (showBtn.value)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(StockJp, {
                  ref: (_value, _refs) => {
                    _refs['stockJpRef'] = _value
                    stockJpRef.value = _value
                  }
                }, null, 512)
              ], 512)), [
                [_vShow, mode.value === 2]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      (!_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 0,
            name: "b2b-shopcart"
          }))
        : _createCommentVNode("", true),
      (_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 1,
            name: "d2c-shopcart"
          }))
        : _createCommentVNode("", true),
      _createVNode(OpenMember, {
        ref: (_value, _refs) => {
          _refs['openMemberRef'] = _value
          openMemberRef.value = _value
        }
      }, null, 512),
      _createVNode(NoStockModal, {
        visible: noStockVisible.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((noStockVisible).value = $event)),
        goods: noStockGoods.value
      }, null, 8, ["visible", "goods"]),
      _createVNode(KrCustomsTip, {
        visible: isShowKrTip.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((isShowKrTip).value = $event)),
        onSuccess: customsCallback,
        type: 1
      }, null, 8, ["visible"]),
      _createVNode(NewUserTip),
      _createVNode(CartBcIntro),
      _createVNode(ChoiceConfirmOrder, {
        list: _unref(choiceFn).getChoiceCheckList(),
        modeConfig: _unref(modes)[mode.value ? 0 : 1],
        modeValue: mode.value,
        ref: (_value, _refs) => {
          _refs['choiceConfirmOrdeRef'] = _value
          choiceConfirmOrdeRef.value = _value
        },
        transportType: _unref(transportType),
        choiceTotalAmount: _unref(totalAmount),
        choiceFn: _unref(choiceFn),
        addressValid: addressValid.value,
        onSuccess: _cache[9] || (_cache[9] = ($event: any) => (_unref(choiceFn).getChoiceList()))
      }, null, 8, ["list", "modeConfig", "modeValue", "transportType", "choiceTotalAmount", "choiceFn", "addressValid"]),
      _createVNode(UnRechargeModal)
    ])
  ], 64))
}
}

})